import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../utils';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    LineElement,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    Filler,
  } from "chart.js";
import GoldPrices from './GoldPrices';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'


  ChartJS.register(
    Title,
    Tooltip,
    LineElement,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    Filler
  );

const Chart = () => {

    const [buyValues, setBuyValues] = useState([]);
    const [sellValues, setSellValues] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [graphCatg, setGraphCatg] = useState("weekly");
 
      const token = localStorage?.getItem("token");

    const [graph, setGraph] = useState({
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "April",
          "May",
          "June",
          "July",
          "August",
          "Sept",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
            {
              label: 'Buy',
              data: [1, 2, 4, 6, 8, 10],
              borderColor: '#25CA71',
              borderWidth: 2,
              pointRadius: 5,
              pointStyle: 'line',
            },
            {
              label: 'Sell',
              data: [1, 2, 4, 6, 8, 10],
              borderColor: '#ED1D25',
              borderWidth: 2,
              pointRadius: 5,
              pointStyle: 'line',
            },
          ],
      });
   
    const options = {
        scales: {
          x: {
            display: true,
        grid: {
          display: true,
        },
            beginAtZero: true,
          },
          y: {
            beginAtZero: true,
            display: true,
        grid: {
          display: false,
        },
          },
        },
      }
 
     const handleGraphValue = (e) => {
       const value = e.target.value;
       setGraphCatg(value);
     }

      useEffect(() => {
        
        if (!dataLoaded || graphCatg === 'weekly') {
          handleBuyWeekly();
          handleSellWeekly();
        } else if (graphCatg === 'monthly') {
          handleBuyMonthly();
          handleSellMonthly();
        }
         setDataLoaded(true);
        
      }, [dataLoaded, graphCatg]);

      useEffect(() => {
        setGraph((prevGraph) => ({
          ...prevGraph,
          datasets: [
            {
              ...prevGraph.datasets[0],
              data: buyValues,
            },
            {
              ...prevGraph.datasets[1],
              data: sellValues,
            },
          ],
        }));
      }, [buyValues, sellValues])

      const handleBuyWeekly = () => {
        axiosInstance
          .post("/api/get-weekly-buy-values", "", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            
            setBuyValues(res.data);
          })
          .catch(err => console.log(err));
      };
      
      const handleSellWeekly = () => {
        axiosInstance
          .post("/api/get-weekly-sell-values", "", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
           
            setSellValues(res.data);
          })
          .catch(err => console.log(err))
      };

      const handleBuyMonthly = () => {
        axiosInstance
          .post("/api/get-monthly-buy-values", "", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setBuyValues(res.data);
          })
          .catch(err => console.log(err));
      };

      const handleSellMonthly = () => {
        axiosInstance
          .post("/api/get-monthly-sell-values", "", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setSellValues(res.data);
          })
          .catch(err => console.log(err));
      };
 
  return (
    <div className='bg-white w-full rounded-md px-6 py-4'>
        <div className='flex justify-between items-center pb-6'>
            <p className='text-smregular text-secondary-n-70'>Today Price</p>
            <select className=''  onChange={handleGraphValue}>
                <option value={"weekly"}>Weekly</option>
                <option value={"monthly"}>Monthly</option>     
            </select>

          
        </div>
        <GoldPrices />

        <div className='flex items-center gap-1'>
        <div className='space-y-4'>
             <div className='flex items-center flex-col gap-3'>
              <p className='writing-vert'>Sell Price</p>
              <div className='w-3 h-3 rounded-full bg-primary-red-500'></div>
             </div>
             <div className='flex items-center flex-col gap-3'>
              <p className='writing-vert'>Buy Price</p>
              <div className='w-3 h-3 rounded-full bg-primary-green'></div>
             </div>
        </div> 
        <div className='w-full h-full'>
           <Line data={graph} options={options}  className='!h-[352px] !w-full' />
        </div>
        </div>
        <ToastContainer />
    </div>
  )
}

export default Chart